
import { Action, ActionType } from "@redux/actionTypes/documentsUpload";
import { Reducer } from "redux";

export interface IDocumentsUploadState {
  documentsUploadById: any[];
}

const initialState = {
  documentsUploadById: [],
};

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: any;
  totalObject: Record<string, any>[];
}

export const documentsUploadReducer: Reducer<IDocumentsUploadState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.DOCUMENTS_UPLOAD_BY_PID:
      return {
        ...state,
        documentsUploadById: action.payload,
      };
    default:
      return state;
  }
};
